class CarouselDots {
  constructor(containerId, options = {}) {
    this.container = document.getElementById(containerId);
    if (!this.container) return;
    
    this.options = {
      itemSelector: '.grid-carousel-item',
      dotsContainerSelector: '[data-carousel-dots]',
      activeClass: 'active',
      mobileBreakpoint: 768,
      ...options
    };
    
    this.carousel = this.container.querySelector('scroll-carousel, [data-carousel]');
    this.dotsContainer = this.container.querySelector(this.options.dotsContainerSelector);
    this.items = this.carousel ? Array.from(this.carousel.querySelectorAll(this.options.itemSelector)) : [];
    this.dots = [];
    this.resizeTimeout = null;
    this.observer = null;
    
    this.init();
  }
  
  init() {
    if (!this.shouldShowDots()) return;
    
    this.createDots();
    this.setupEventListeners();
    this.setupIntersectionObserver();
  }
  
  shouldShowDots() {
    if (window.innerWidth < this.options.mobileBreakpoint) {
      return this.items.length > 1; // Always show dots on mobile if more than 1 item
    }
    
    if (!this.carousel) return false;
    
    const containerWidth = this.carousel.offsetWidth;
    const itemsWidth = this.items.reduce((total, item) => total + item.offsetWidth, 0);
    const needsDots = itemsWidth > containerWidth + 10; // Small buffer
    
    if (this.dotsContainer) {
    //   this.dotsContainer.style.display = needsDots ? 'flex' : 'none';
    }
    
    return needsDots;
  }
  
  createDots() {
    if (!this.dotsContainer) return;
    
    this.dotsContainer.innerHTML = '';
    this.dots = [];
    
    this.items.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot' + (index === 0 ? ` ${this.options.activeClass}` : '');
      dot.setAttribute('data-index', index);
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        this.scrollToIndex(index);
      });
      
      this.dotsContainer.appendChild(dot);
      this.dots.push(dot);
    });
  }
  
  scrollToIndex(index) {
    if (!this.items[index]) return;
    
    this.items[index].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    });
    
    this.updateActiveDot(index);
  }
  
  updateActiveDot(activeIndex) {
    this.dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add(this.options.activeClass);
      } else {
        dot.classList.remove(this.options.activeClass);
      }
    });
  }
  
  setupEventListeners() {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        this.handleResize();
      }, 100);
    });
  }
  
  handleResize() {
    const shouldShow = this.shouldShowDots();
    
    if (shouldShow && this.dots.length === 0) {
      this.createDots();
      this.setupIntersectionObserver();
    } else if (!shouldShow && this.dots.length > 0) {
      this.dotsContainer.innerHTML = '';
      this.dots = [];
      
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }
  
  setupIntersectionObserver() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const index = this.items.indexOf(entry.target);
          if (index !== -1) {
            this.updateActiveDot(index);
          }
        }
      });
    }, {
      root: this.carousel,
      threshold: 0.5
    });
    
    this.items.forEach(item => this.observer.observe(item));
  }
  
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    window.removeEventListener('resize', this.handleResize);
    
    if (this.dotsContainer) {
      this.dotsContainer.innerHTML = '';
    }
  }
}

// Auto-initialize carousels with data-carousel-container attribute
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-carousel-container]').forEach(container => {
    const carouselId = container.id || `carousel-${Math.random().toString(36).substr(2, 9)}`;
    if (!container.id) container.id = carouselId;
    
    // Only initialize if there's a dots container
    const dotsContainer = container.querySelector('[data-carousel-dots]');
    if (dotsContainer) {
      new CarouselDots(carouselId);
    }
  });
});
